export enum StatusType {
    Configure = 1,
    Live = 2,
    Paused = 3,
    Deleted = 4,
    Ended = 5
}
